
import { defineComponent, PropType } from 'vue'

// @components
import Cheap from '@/common/components/UI/Cheap/index.vue'

// @types
import { Courier } from '@/new-services/types/couriers'

// @helpers
import cut from '@/common/helpers/cut'

import { formatDateFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    name: 'couriers-table-row',
    components: { Cheap },
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
    },
    setup(props) {
        const getCreatedAtDate = (courier: Courier) => {
            if (courier.createdAt) {
                let date = courier.createdAt.split(' ')[0]
                return formatDateFromBackend(date)
            }

            return '-'
        }

        const getCreatedAtTime = (courier: Courier) => {
            if (courier.createdAt) {
                let time = courier.createdAt.split(' ')[1]
                return time
            }

            return '-'
        }

        return {
            cut,
            getCreatedAtDate,
            getCreatedAtTime,
        }
    },
})
